<script>
export default {
  name: "IconGreenLetter"
};
</script>

<template>
  <svg width="20" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.33 0H.67C.3 0 0 .3 0
.67v14.66c0 .37.3.67.67.67h18.66c.37 0 .67-.3.67-.67V.67c0-.37-.3-.67-.67-.67zm-1.8 1.33L10 7.8 2.47
1.33h15.06zM1.33 14.67V2.12l8.24 7.05c.25.22.61.22.86 0l8.24-7.05v12.55H1.33z"
      fill="#00A489"
      fill-rule="nonzero"
    />
  </svg>
</template>
